import {Component, Inject, Optional} from '@angular/core';
import {DIALOG_DATA} from 'src/app/services/dialog.service';
import {DialogRef} from '../../dialog/dialog-ref';
import {ISureConfig} from 'src/app/interfaces/sure-modal.interface';
/**
 * Sure modal component that user received when the data isn't saved
 */
@Component({
  selector: 'app-sure-modal',
  templateUrl: './sure-modal.component.html',
  styleUrls: ['./sure-modal.component.scss'],
})
export class SureModalComponent {
  constructor(
    private dialogRef: DialogRef,
    @Optional()
    @Inject(DIALOG_DATA)
    public data: ISureConfig
  ) {}

  reject() {
    this.dialogRef.close();
  }

  accept() {
    this.dialogRef.close(true);
  }
}
